/**
 * Rolotoys — Android-safe header search toggle
 * Replaces CSS :has() for hiding cart/account when search is open.
 */
(function () {
  function bindSearch(details) {
    if (!details || details.dataset.roloSearchBound) return;
    details.dataset.roloSearchBound = '1';

    var sync = function () {
      document.body.classList.toggle('rolo-search-open', details.hasAttribute('open'));
    };

    details.addEventListener('toggle', sync);
    sync();
  }

  function init() {
    document.querySelectorAll('.header__search details').forEach(bindSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

